(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["refit-cart-terms"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('refit-cart-terms')) {
    class RefitCartTerms extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.checkbox = this.querySelector('[data-refit-terms-checkbox]');
        this.timestamp = this.querySelector('[data-refit-terms-time]');
        this.error = this.querySelector('[role="alert"]');
        this.form = this.closest('form');
        if (!this.checkbox || !this.form) return;

        this.querySelector('[data-refit-terms-url]').value = this.querySelector('a').href;
        this.update();
        this.checkbox.addEventListener('change', () => this.update(), options);
        this.checkbox.addEventListener('invalid', (event) => {
          event.preventDefault();
          this.showError();
        }, options);
        this.form.addEventListener('submit', (event) => {
          if (!this.checkbox.checked) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.showError();
            return;
          }
          if (!this.timestamp.value) this.timestamp.value = new Date().toISOString();
        }, { ...options, capture: true });
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      update() {
        const accepted = this.checkbox.checked;
        this.checkbox.setCustomValidity(accepted ? '' : this.dataset.error);
        this.timestamp.value = accepted ? new Date().toISOString() : '';
        this.error.hidden = true;
        this.checkbox.removeAttribute('aria-invalid');
      }

      showError() {
        this.error.hidden = false;
        this.checkbox.setAttribute('aria-invalid', 'true');
        this.checkbox.focus({ preventScroll: true });
        this.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    }

    customElements.define('refit-cart-terms', RefitCartTerms);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["refit-terms-app-localization"] && !Shopify.designMode) return;
  try {
    (() => {
    const data = document.getElementById('refit-terms-app-localization');
    if (!data) return;

    const translations = JSON.parse(data.textContent);
    const selector = '.rale-widget[data-rale-id="1"]';
    const [before, after = ''] = translations.message.split('REFIT_TERMS_LINK');
    const expectedText = before + translations.link + after;

    const localize = () => {
      document.querySelectorAll(selector).forEach((widget) => {
        const label = widget.querySelector('.rale-message');
        const link = label?.querySelector('a.rale-link');
        if (!label || !link) return;

        if (link.getAttribute('href') !== translations.url) {
          link.setAttribute('href', translations.url);
        }
        if (link.textContent !== translations.link) {
          link.textContent = translations.link;
        }
        if (label.textContent !== expectedText) {
          label.replaceChildren(document.createTextNode(before), link, document.createTextNode(after));
        }
      });
    };

    const originalAlert = window.alert;
    window.alert = function (message) {
      const isTermsError = message === 'Please agree to the terms and conditions before proceeding to checkout!';
      return originalAlert.call(this, isTermsError && document.querySelector(selector) ? translations.error : message);
    };

    localize();
    new MutationObserver(localize).observe(document.body, { childList: true, subtree: true, characterData: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
